module.exports = __webpack_public_path__ + "static/media/bank-shield-color.7b8fc61a.png";